export default "__VITE_ASSET__ca2tcD92__"